(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fnk-collection-navigation"] && !Shopify.designMode) return;
  try {
    
  const initializeCollectionNavigation = (root = document) => {
    const navigations = root.matches?.('[data-fnk-collection-navigation]')
      ? [root]
      : root.querySelectorAll('[data-fnk-collection-navigation]');

    navigations.forEach((navigation) => {
      if (navigation.dataset.collectionNavigationReady === 'true') return;
      navigation.dataset.collectionNavigationReady = 'true';

      const scroller = navigation.querySelector('[data-fnk-collection-navigation-scroller]');
      const activeLink = navigation.querySelector('[aria-current="page"]');
      if (!scroller || !activeLink) return;

      requestAnimationFrame(() => {
        const targetLeft = activeLink.offsetLeft - (scroller.clientWidth - activeLink.offsetWidth) / 2;
        scroller.scrollTo({ left: targetLeft, behavior: 'auto' });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCollectionNavigation(), { once: true });
  } else {
    initializeCollectionNavigation();
  }

  document.addEventListener('shopify:section:load', (event) => initializeCollectionNavigation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnk-collection-slider"] && !Shopify.designMode) return;
  try {
    
  const initializeCollectionRail = (root) => {
    if (root.dataset.collectionRailReady === 'true') return;
    root.dataset.collectionRailReady = 'true';

    const track = root.querySelector('[data-collection-track]');
    const previous = root.querySelector('[data-collection-direction="previous"]');
    const next = root.querySelector('[data-collection-direction="next"]');
    if (!track || !previous || !next) return;

    const updateControls = () => {
      const maximum = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2;
    };

    const move = (direction) => {
      const distance = Math.max(track.clientWidth * 0.8, 280);
      track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  };

  const initializeCollectionRails = (scope = document) => {
    scope.querySelectorAll('[data-fnk-collection-rail]').forEach(initializeCollectionRail);
  };

  initializeCollectionRails();
  document.addEventListener('shopify:section:load', (event) => initializeCollectionRails(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnk-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fnk-customer-reviews')) {
    customElements.define('fnk-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.classList.contains('fnk-reviews--grid')) return;
        this.track = this.querySelector('.fnk-reviews__track');
        this.previous = this.querySelector('[data-review-previous]');
        this.next = this.querySelector('[data-review-next]');
        if (!this.track || !this.previous || !this.next) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.setAttribute('data-enhanced', '');
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      move(direction) {
        const card = this.track.querySelector('.fnk-reviews__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const sign = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({
          left: direction * sign * (card.getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }

      update() {
        const position = Math.abs(this.track.scrollLeft);
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnk-product-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fnk-product-videos')) {
    customElements.define('fnk-product-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.dialogs = Array.from(this.querySelectorAll('dialog'));
        this.querySelectorAll('video').forEach(video => this.prepareVideo(video));
        this.rail = this.querySelector('.fnk-videos__rail');
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.scrollRail(this.rail, Number(button.dataset.direction))));
        this.querySelectorAll('[data-open]').forEach(button => {
          const dialog = this.querySelector('#' + CSS.escape(button.dataset.open));
          const warm = () => this.warmProducts(dialog);
          button.addEventListener('pointerenter', warm);
          button.addEventListener('focus', warm);
          button.addEventListener('pointerdown', warm);
          button.addEventListener('click', () => { this.opener = button; this.openVideo(dialog); });
        });
        this.dialogs.forEach(dialog => {
          const video = dialog.querySelector('.fnk-videos__full-video');
          const play = dialog.querySelector('[data-play]');
          const syncPlay = () => {
            video.parentElement.toggleAttribute('data-paused', video.paused);
            play.setAttribute('aria-label', video.paused ? play.dataset.playLabel : play.dataset.pauseLabel);
          };
          video.addEventListener('play', syncPlay);
          video.addEventListener('pause', syncPlay);
          dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
          dialog.addEventListener('close', () => {
            video.pause();
            if (!document.querySelector('dialog[open]')) { this.opener?.focus({ preventScroll:true }); this.resumePreviews(); }
          });
          play.addEventListener('click', () => video.paused ? video.play().catch(() => {}) : video.pause());
          const mute = dialog.querySelector('[data-mute]');
          mute.addEventListener('click', () => { video.muted = !video.muted; this.syncSound(dialog); });
          dialog.querySelectorAll('[data-video-direction]').forEach(button => button.addEventListener('click', () => this.nextVideo(dialog, Number(button.dataset.videoDirection))));
          this.bindVideoGestures(dialog);
          dialog.querySelectorAll('[data-select-product]').forEach(button => button.addEventListener('click', () => this.selectProduct(dialog, button.dataset.selectProduct)));
          dialog.querySelector('[data-quick-shop]')?.addEventListener('click', () => this.setShopOpen(dialog, true));
          dialog.querySelectorAll('[data-close-shop]').forEach(button => button.addEventListener('click', () => this.setShopOpen(dialog, false)));
          dialog.addEventListener('cancel', event => { if (!dialog.querySelector('.fnk-videos__shop-panel').hidden) { event.preventDefault(); this.setShopOpen(dialog, false); } });
          dialog.querySelector('[data-video-cart]').addEventListener('click', event => {
            const drawer = document.querySelector('cart-drawer-component');
            if (typeof drawer?.open === 'function') { event.preventDefault(); dialog.close(); drawer.open(); }
          });
          dialog.querySelectorAll('[data-choose-variant]').forEach(button => button.addEventListener('click', () => {
            const select = button.closest('form').querySelector('[data-video-variant]');
            select.value = button.dataset.chooseVariant;
            select.dispatchEvent(new Event('change', { bubbles:true }));
          }));
          this.selectProduct(dialog);
          dialog.addEventListener('keydown', event => {
            if (event.key === 'Escape' && !dialog.querySelector('.fnk-videos__shop-panel').hidden) { event.preventDefault(); event.stopPropagation(); this.setShopOpen(dialog, false); return; }
            if (event.target.closest('select,input,textarea,.fnk-videos__shop-panel,.fnk-videos__product-actions')) return;
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); this.nextVideo(dialog, event.key === 'ArrowDown' ? 1 : -1); }
          });
          dialog.querySelectorAll('[data-video-variant]').forEach(select => select.addEventListener('change', () => {
            const form = select.closest('form');
            const option = select.selectedOptions[0];
            form.querySelector('[name="id"]').value = select.value;
            form.querySelector('[name="quantity"]').value = option.dataset.quantity;
            const card = select.closest('[data-shop-product]');
            card.querySelector('[data-price]').textContent = option.dataset.price;
            card.querySelectorAll('[data-choose-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.chooseVariant === select.value)));
            dialog.querySelector('[data-active-price]').textContent = option.dataset.price;
          }));
        });
        this.dialogs.slice(0,2).forEach(dialog => this.warmProducts(dialog));
        this.addEventListener('cart:update', event => {
          if (!event.detail?.data?.didError && event.target.closest?.('[data-shop-product]')) this.querySelector('dialog[open]')?.close();
        });
        this.visiblePreviews = new Set();
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            this.visiblePreviews.add(video);
            const dialog = video.closest('.fnk-videos__card').querySelector('dialog');
            this.warmProducts(dialog);
            this.warmProducts(this.dialogs[this.dialogs.indexOf(dialog)+1]);
            if (!this.motion.matches && !document.hidden && !this.querySelector('dialog[open]')) video.play().catch(() => {});
          } else { this.visiblePreviews.delete(video); video.pause(); }
        }), { threshold:0.5 });
        this.querySelectorAll('.fnk-videos__preview').forEach(video => this.observer.observe(video));
        this.onVisibility = () => {
          if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
          else if (!this.querySelector('dialog[open]')) this.resumePreviews();
        };
        document.addEventListener('visibilitychange', this.onVisibility);
      }
      openVideo(dialog, previous) {
        this.querySelectorAll('video').forEach(video => video.pause());
        const muted = previous ? previous.querySelector('video').muted : true;
        if (previous) previous.close();
        dialog.showModal();
        dialog.scrollTop = 0;
        this.warmProducts(dialog);
        const video = dialog.querySelector('.fnk-videos__full-video');
        video.muted = muted;
        this.syncSound(dialog);
        this.setShopOpen(dialog, false, false);
        this.selectProduct(dialog, dialog.dataset.selectedProduct);
        const index = this.dialogs.indexOf(dialog);
        const position = dialog.querySelector('[data-video-position]');
        position.textContent = (index+1) + ' / ' + this.dialogs.length;
        position.setAttribute('aria-label', position.dataset.label.replace('__INDEX__', index+1).replace('__TOTAL__', this.dialogs.length));
        dialog.querySelectorAll('[data-video-direction]').forEach(button => {
          button.hidden = this.dialogs.length < 2;
          button.disabled = Number(button.dataset.videoDirection) < 0 ? index === 0 : index === this.dialogs.length-1;
          if (button.classList.contains('fnk-videos__next-look')) button.hidden = index === this.dialogs.length-1;
        });
        dialog.querySelector('.fnk-videos__swipe-hint').hidden = index === this.dialogs.length-1;
        video.play().catch(() => {});
        this.warmProducts(this.dialogs[index-1]);
        const next = this.dialogs[index+1];
        this.warmProducts(next);
        const connection = navigator.connection;
        if (next && !connection?.saveData && !['slow-2g','2g'].includes(connection?.effectiveType)) {
          const upcoming = next.querySelector('.fnk-videos__full-video');
          if (upcoming.preload === 'none') { upcoming.preload = 'auto'; upcoming.load(); }
        }
      }
      nextVideo(dialog, direction) {
        const next = this.dialogs[this.dialogs.indexOf(dialog) + direction];
        if (next && dialog.open) this.openVideo(next, dialog);
      }
      bindVideoGestures(dialog) {
        const viewer = dialog.querySelector('.fnk-videos__viewer');
        let gesture = null;
        viewer.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button > 0 || event.target.closest('button:not([data-play]),a,.fnk-videos__product-actions')) return;
          gesture = { id:event.pointerId, x:event.clientX, y:event.clientY };
        });
        viewer.addEventListener('pointermove', event => {
          if (!gesture || event.pointerId !== gesture.id) return;
          const dx = event.clientX-gesture.x, dy = event.clientY-gesture.y;
          if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)*1.25) {
            viewer.setPointerCapture(event.pointerId);
            event.preventDefault();
          }
        });
        viewer.addEventListener('pointerup', event => {
          if (!gesture || event.pointerId !== gesture.id) return;
          const dx = event.clientX-gesture.x, dy = event.clientY-gesture.y;
          gesture = null;
          if (Math.max(Math.abs(dx),Math.abs(dy)) > 12) this.swipedUntil = Date.now()+400;
          if (Math.abs(dy) >= 55 && Math.abs(dy) > Math.abs(dx)*1.25) {
            event.preventDefault();
            this.swipedUntil = Date.now()+400;
            this.nextVideo(dialog, dy < 0 ? 1 : -1);
          }
        });
        viewer.addEventListener('pointercancel', () => { gesture = null; });
        viewer.addEventListener('click', event => {
          if (Date.now() < (this.swipedUntil || 0)) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, true);
        let wheel = 0;
        viewer.addEventListener('wheel', event => {
          if (event.target.closest('.fnk-videos__product-actions') || event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
          event.preventDefault();
          if (Date.now() < (this.wheelUntil || 0)) return;
          wheel += event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewer.clientHeight : 1);
          if (Math.abs(wheel) >= 90) { this.wheelUntil = Date.now()+650; this.nextVideo(dialog, wheel > 0 ? 1 : -1); wheel = 0; }
        }, { passive:false });
      }
      warmProducts(dialog) {
        dialog?.querySelectorAll('.fnk-videos__product-image,.fnk-videos__product-thumb img').forEach(image => { image.loading = 'eager'; });
      }
      syncSound(dialog) {
        const video = dialog.querySelector('video');
        const mute = dialog.querySelector('[data-mute]');
        mute.setAttribute('aria-label', video.muted ? mute.dataset.unmuteLabel : mute.dataset.muteLabel);
        mute.setAttribute('aria-pressed', String(!video.muted));
        mute.querySelector('[data-sound-off]').hidden = !video.muted;
        mute.querySelector('[data-sound-on]').hidden = video.muted;
      }
      resumePreviews() {
        if (!document.hidden && !this.motion.matches) this.visiblePreviews?.forEach(video => video.play().catch(() => {}));
      }
      prepareVideo(video) {
        const reveal = () => { if (video.readyState >= 2) video.setAttribute('data-frame-ready', ''); };
        const waitForFrame = () => {
          if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(reveal);
          else if (video.readyState >= 2) requestAnimationFrame(() => requestAnimationFrame(reveal));
        };
        video.addEventListener('loadeddata', waitForFrame);
        video.addEventListener('playing', waitForFrame);
        video.addEventListener('emptied', () => video.removeAttribute('data-frame-ready'));
        video.addEventListener('error', () => video.removeAttribute('data-frame-ready'));
        waitForFrame();
      }
      scrollRail(rail, direction) {
        const item = rail.firstElementChild;
        if (item) rail.scrollBy({ left:(item.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0)) * direction, behavior:this.motion.matches ? 'instant' : 'smooth' });
      }
      selectProduct(dialog, productId) {
        const cards = Array.from(dialog.querySelectorAll('[data-shop-product]'));
        const card = cards.find(item => item.dataset.productId === productId) || cards[0];
        dialog.querySelector('.fnk-videos__caption small').hidden = cards.length < 2;
        if (!card) { dialog.querySelector('[data-product-position]').textContent = ''; return; }
        dialog.dataset.selectedProduct = card.dataset.productId;
        cards.forEach(item => { item.hidden = item !== card; });
        dialog.querySelectorAll('[data-select-product]').forEach((button,index) => {
          button.setAttribute('aria-pressed', String(button.dataset.selectProduct === card.dataset.productId));
          button.querySelector('[data-product-number]').textContent = index+1;
        });
        dialog.querySelector('[data-product-position]').textContent = ' · ' + (cards.indexOf(card)+1) + ' / ' + cards.length;
        dialog.querySelector('[data-active-title]').textContent = card.querySelector('.fnk-videos__product-title').textContent;
        dialog.querySelector('[data-active-price]').textContent = card.querySelector('[data-price]').textContent;
        const image = card.querySelector('.fnk-videos__product-image');
        const target = dialog.querySelector('[data-active-image]');
        target.replaceChildren();
        target.hidden = !image;
        if (image) { const copy = image.cloneNode(true); copy.loading = 'eager'; target.append(copy); }
      }
      setShopOpen(dialog, open, focus = true) {
        dialog.querySelectorAll('.fnk-videos__viewer,.fnk-videos__compact-shop,.fnk-videos__feed-footer').forEach(element => { element.inert = open; });
        dialog.querySelector('.fnk-videos__shop-panel').hidden = !open;
        dialog.querySelector('.fnk-videos__shop-scrim').hidden = !open;
        dialog.querySelector('[data-quick-shop]')?.setAttribute('aria-expanded', String(open));
        if (!focus) return;
        const target = open ? dialog.querySelector('[data-shop-product]:not([hidden]) [data-choose-variant][aria-pressed="true"]:not([disabled]), [data-shop-product]:not([hidden]) button[type="submit"]:not([disabled])') || dialog.querySelector('.fnk-videos__shop-heading [data-close-shop]') : dialog.querySelector('[data-quick-shop]');
        target?.focus({ preventScroll:true });
      }
      disconnectedCallback() { this.observer?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); document.removeEventListener('visibilitychange', this.onVisibility); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnk-reward-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fnk-reward-announcements')) {
    customElements.define('fnk-reward-announcements', class extends HTMLElement {
      connectedCallback() {
        this.onUpdate = () => {
          clearTimeout(this.timer);
          this.request?.abort();
          this.timer = setTimeout(() => this.refresh(), 100);
        };
        this.onPageShow = (event) => { if (event.persisted) this.onUpdate(); };
        document.addEventListener('cart:update', this.onUpdate);
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.request?.abort();
        document.removeEventListener('cart:update', this.onUpdate);
        window.removeEventListener('pageshow', this.onPageShow);
      }

      async refresh() {
        this.request = new AbortController();
        const request = this.request;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) return;
          const html = await response.text();
          if (request.signal.aborted || !this.isConnected) return;
          const updated = new DOMParser().parseFromString(html, 'text/html')
            .querySelector('fnk-reward-announcements .cart-reward-tiers');
          const current = this.querySelector('.cart-reward-tiers');
          if (updated && current && updated.innerHTML !== current.innerHTML) {
            current.className = updated.className;
            current.innerHTML = updated.innerHTML;
          }
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('[FNK reward announcement]', error);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnk-tabbed-catalog"] && !Shopify.designMode) return;
  try {
    
  const initializeTabbedCatalog = (root) => {
    if (root.dataset.tabbedCatalogReady === 'true') return;
    root.dataset.tabbedCatalogReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-catalog-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-catalog-panel]'));
    if (tabs.length === 0 || panels.length === 0) return;

    const activateTab = (tab, focus = false) => {
      const targetId = tab.dataset.catalogTab;
      tabs.forEach((candidate) => {
        const active = candidate === tab;
        candidate.setAttribute('aria-selected', String(active));
        candidate.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });
      tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (focus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === index) return;
        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });
  };

  const initializeTabbedCatalogs = (scope = document) => {
    scope.querySelectorAll('[data-fnk-tabbed-catalog]').forEach(initializeTabbedCatalog);
  };

  initializeTabbedCatalogs();
  document.addEventListener('shopify:section:load', (event) => initializeTabbedCatalogs(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-catalog-panel]');
    const root = event.target.closest('[data-fnk-tabbed-catalog]');
    if (!panel || !root) return;
    const tab = root.querySelector(`[data-catalog-block-id="${panel.dataset.catalogBlockId}"]`);
    if (tab) tab.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
